import React from 'react';
import ReactDOM from 'react-dom/client'; // <-- import for React 18+

type AlertModalProps = {
  isOpen: boolean;
  message: string;
  onClose: () => void;
};

export const AlertModal: React.FC<AlertModalProps> = ({ isOpen, onClose, message }) => {
  if (!isOpen) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        background: 'rgba(0,0,0,0.5)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        zIndex: 1000,
      }}
    >
      <div style={{ background: '#fff', padding: 24, borderRadius: 8, minWidth: 300 }}>
        <h2>{message}</h2>
        <br />
        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 8 }}>
          <button onClick={onClose}>OK</button>
        </div>
      </div>
    </div>
  );
};

// Usage helper to "pause" until OK is pressed
export function showAlertModal(message: string): Promise<string | null> {
  return new Promise((resolve) => {
    const modalRoot = document.createElement('div');
    document.body.appendChild(modalRoot);

    const root = ReactDOM.createRoot(modalRoot);

    function cleanup() {
      root.unmount();
      document.body.removeChild(modalRoot);
    }

    const handleClose = () => {
      cleanup();
      resolve(null);
    };

    root.render(<AlertModal isOpen onClose={handleClose} message={message} />);
  });
}
